import React, { useState, useRef } from 'react';
import { TabContent, TabPane, Card, CardBody, CardHeader } from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiThumbDownOutline, mdiThumbUpOutline } from '@mdi/js';
import { MyApprovals, MyRequests } from '../../../components/Approvals';
import './Approvals.scss';
import { withBase } from '../../../utils/route.util';

function Approvals() {
  document.title = 'Approvals | Envision - Daikin';
  const location = useLocation();
  const { pathname } = window.location;
  const isHRPath = pathname.includes('/hr');
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const urlTab = query.get('t') || 'app';
  const [activeTab, setActiveTab] = useState(urlTab === 'app' ? '1' : '2');
  const [hasSelection, setHasSelection] = useState(false);
  const approvalRef = useRef(null);
  const [counts, setCounts] = useState({
    myApprovals: 0,
    myRequests: 0,
  });

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
    const type = tab === '1' ? 'app' : 'req';
    const newUrl = withBase(`${location.pathname}?t=${type}`);
    window.history.replaceState(null, '', newUrl);
  };

  const handleEditClick = (item, type = null) => {
    const requestType = item.RequestType.toLowerCase();
    if (requestType === 'leave') {
      navigate(
        `${
          isHRPath ? '/hr' : ''
        }/leave/apply?CoCd=${item?.CoCd}&ID=${item?.RequestID}&EmpCode=${item?.EmployeeID}`,
      );
    }
    if (requestType === 'overtime') {
      navigate(
        `${
          isHRPath ? '/hr' : ''
        }/overtime/apply?CoCd=${item?.CoCd}&ID=${item?.RequestID}`,
      );
    }
    if (requestType === 'compensatory off') {
      navigate(
        `${
          isHRPath ? '/hr' : ''
        }/comp-off/apply?CoCd=${item?.CoCd}&ID=${item?.RequestID}`,
      );
    }
    if (requestType === 'wfh') {
      navigate(
        `${
          isHRPath ? '/hr' : ''
        }/wfh/apply?CoCd=${item?.CoCd}&ID=${item?.RequestID}`,
      );
    }
    if (requestType === 'loan') {
      navigate(`${isHRPath ? '/hr' : ''}/loan/apply?ID=${item?.RequestID}`);
    }
    if (requestType === 'time registeration') {
      navigate(
        `${
          isHRPath ? '/hr' : ''
        }/timesheet/attendance?CoCd=${item?.CoCd.trim()}&ID=${item?.RequestID}`,
      );
    }
    if (requestType === 'travel request') {
      if (type === 'approval') {
        navigate(
          `${
            isHRPath ? '/hr' : ''
          }/travel-request/approval?id=${item?.RequestID}&t=${item?.Typ}`,
          { state: item },
        );
      } else {
        navigate(
          `${
            isHRPath ? '/hr' : ''
          }/travel-request/options/${item?.RequestID}/${item?.Typ}`,
        );
      }
    }

    if (requestType === 'expense claim') {
      if (type === 'approval') {
        navigate(
          `${isHRPath ? '/hr' : ''}/expense/claim?ID=${item?.RequestID}&Type=ENQUIRY&Mode=APPROVE&CoCd=${item?.CoCd}&AppTyp=${item?.Typ}&AppRank=${item?.ApprovalRank}&ExpApprDetails=${item?.RequestDate}~~${item?.Requester}~${item?.CoCd.trim()}`,
        );
      } else {
        navigate(
          `${isHRPath ? '/hr' : ''}/expense/claim?ID=${item?.RequestID}&Type=ENQUIRY&Mode=APPROVE&CoCd=${item?.CoCd}&AppTyp=${item?.Typ}&AppRank=${item?.ApprovalRank}`,
        );
      }
    }
  };

  return (
    <div className="page-content approval-page">
      <Card className="approvals-card">
        <CardHeader
          className="p-0 d-flex flex-row justify-content-between align-items-center"
          style={{ borderRadius: '10px 10px 0 0', height: '55px' }}
        >
          <ul className="nav nav-underline" style={{ height: '50px' }}>
            <button
              type="button"
              onClick={() => toggle('1')}
              className={`cursor-pointer nav-link px-2 py-2 nav-link d-flex flex-row align-items-center ${
                activeTab === '1' ? 'active' : ''
              }`}
              style={{
                backgroundColor: activeTab === '1' ? '#F0F9FF' : 'transparent',
                borderRadius: '10px 0 0 0',
              }}
            >
              <span style={{ fontWeight: activeTab !== '1' && '600' }}>
                My Approvals
              </span>
              <div
                className={`ms-1 ${activeTab === '1' ? 'count-badge-active' : 'count-badge-inactive'}`}
              >
                {counts.myApprovals || 0}
              </div>
            </button>
            <button
              type="button"
              onClick={() => toggle('2')}
              className={`cursor-pointer nav-link py-2 px-2 nav-link d-flex flex-row align-items-center ${
                activeTab === '2' ? 'active' : ''
              }`}
              style={{
                backgroundColor: activeTab === '2' ? '#F0F9FF' : 'transparent',
              }}
            >
              <span style={{ fontWeight: activeTab !== '2' && '600' }}>
                My Requests
              </span>
              <div
                className={`ms-1 ${activeTab === '2' ? 'count-badge-active' : 'count-badge-inactive'}`}
              >
                {counts.myRequests || 0}
              </div>
            </button>
          </ul>
          {activeTab === '1' && (
            <div className="d-flex flex-row justify-content-end align-items-center gap-2 px-3">
              <button
                type="button"
                className="custom-danger-btn py-2"
                disabled={!hasSelection}
                onClick={() => approvalRef.current.rejectAll()}
                title="Reject the selected request. A reason is required."
              >
                <Icon path={mdiThumbDownOutline} size={0.7} color="#fff" />
                <span className="ms-1">Reject</span>
              </button>
              <button
                type="button"
                className="custom-success-btn py-2"
                disabled={!hasSelection}
                onClick={() => approvalRef.current.approveAll()}
                title="Approve the selected request after reviewing the details."
              >
                <Icon path={mdiThumbUpOutline} size={0.7} color="#fff" />
                <span className="ms-1">Approve</span>
              </button>
            </div>
          )}
        </CardHeader>
        <CardBody className="p-0">
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <MyApprovals
                ref={approvalRef}
                setCounts={setCounts}
                setSelectedRows={setHasSelection}
                handleEditClick={item => handleEditClick(item, 'approval')}
              />
            </TabPane>
            <TabPane tabId="2">
              <MyRequests
                setCounts={setCounts}
                handleEditClick={item => handleEditClick(item, 'request')}
              />
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </div>
  );
}

export default Approvals;
